/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ApplyIdComponent } from "../../components/detailing/apply-id/apply-id.component";
import { ApplyIdInfo } from "../../models/apply-id-model";
import { SysquePopupConfig } from "../../models/sysque-popup-config";
import { PopupDialog } from "../popup-dialog.interface";

export class ApplyConduitIdDialog implements PopupDialog{
    
        create(sysquePopupConfig: SysquePopupConfig): any {
            sysquePopupConfig.component = ApplyIdComponent;
            sysquePopupConfig.data = new ApplyIdInfo();
            (sysquePopupConfig.data as ApplyIdInfo).textId = "Conduit ID";
            (sysquePopupConfig.data as ApplyIdInfo).buttonName = "Apply";
            sysquePopupConfig.width = 416;
            sysquePopupConfig.height = 210;
            sysquePopupConfig.componentTitle = "Apply Conduit ID";
        }
}